<template>
  <div id="app">
    <section class="section" style="padding-top: 0">
        <div class="container">
            <navigation />
        </div>

        <div class="container">
            <router-view />
        </div>

        <footer class="footer" style="margin-top: 3rem;">
          <div class="content has-text-centered">
            <p>
              <strong>Orthodontic index</strong> by Eklundh & Hjorth. Use freely. Questions or contributions, please contact <a href="mailto:admin@orthodonticindex.com" target="_top">admin@orthodonticindex.com</a>.
            </p>
          </div>
        </footer>
    </section>
  </div>
</template>

<script>

import navigation from './components/navigation.vue'

export default {
  name: 'app',
  components: {
    navigation
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
